import { Typography } from "@mui/material";

const KpiSuppression = () => (
  <Typography variant="caption" sx={{ color: "rgba(0, 0, 0, 0.75)", opacity: 0.75 }}>
    In order to protect privacy small values are not reported
  </Typography>
);

export default KpiSuppression;
